// Price-vs-fair-value position maths for the RangeBar (pure, tested).
//
// The track is a linear window from WINDOW_MIN x fair value (left edge) to
// WINDOW_MAX x fair value (right edge) with the fair-value tick at the exact
// centre - 0.25x..1.75x (decided 2026-09-13): the typical 15-30 % discounts
// sit clearly left of centre and deep-value names still discriminate instead
// of pinning to the edge. A price outside the window is clamped and flagged
// so the marker can draw an overflow arrow.

export const WINDOW_MIN = 0.25;
export const WINDOW_MAX = 1.75;

const toNumber = (v) => {
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? n : null;
};

/**
 * @returns {null | {ratio, percent, clamped: 'left'|'right'|null, side: 'below'|'above'|'at', discountPct}}
 *   percent = marker position along the track, 0..100 (50 = fair value).
 *   discountPct = (fv - price) / fv * 100, positive when the price is below fair value.
 */
export function rangePosition(price, fairValue) {
  const p = toNumber(price);
  const fv = toNumber(fairValue);
  if (p === null || fv === null || p <= 0 || fv <= 0) return null;
  const ratio = p / fv;
  const span = WINDOW_MAX - WINDOW_MIN;
  let clamped = null;
  let bounded = ratio;
  if (ratio < WINDOW_MIN) { bounded = WINDOW_MIN; clamped = 'left'; }
  if (ratio > WINDOW_MAX) { bounded = WINDOW_MAX; clamped = 'right'; }
  const percent = ((bounded - WINDOW_MIN) / span) * 100;
  const side = ratio < 0.999 ? 'below' : ratio > 1.001 ? 'above' : 'at';
  return { ratio, percent, clamped, side, discountPct: ((fv - p) / fv) * 100 };
}

/** "$1,234.56" style, tabular-friendly; null-safe. */
export function formatMoney(v) {
  const n = toNumber(v);
  if (n === null) return '—';
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
